import { TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
  StyledTableHeader,
  StyledTableWrapper,
} from 'components/table/table.styled';
import { RatingFilterFormPaginated } from 'features/rating/components/rating-filter-form/type';
import { usePermissions } from 'features/users';
import { Dispatch, SetStateAction } from 'react';
import { Package } from 'types/package';
import { UserWithithdraw } from 'types/withdraw';
type RatingTableProps = {
  isLoading: boolean;
  data?: any;
  tableParams: RatingFilterFormPaginated;
  updateParams: Dispatch<SetStateAction<RatingFilterFormPaginated>>;
};

export const RatingViewTable = ({
  data,
  isLoading,
  tableParams,
  updateParams,
}: RatingTableProps) => {
  const permissions = usePermissions();
  if (!permissions) return null;
  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<UserWithithdraw> | SorterResult<UserWithithdraw>[],
  ) => {
    const sortBy = () => {
      if (Array.isArray(sorter)) return;

      const sortOrder =
        sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`;

      if (sorter?.field === 'last_transaction_date') {
        return {
          order_by_balance: undefined,
          order_by_transaction: sortOrder,
        };
      }
    };

    updateParams({
      ...tableParams,
      page: pagination.current,
      size: pagination.pageSize,
      ...sortBy(),
    });
  };

  return (
    <StyledTableWrapper>
      <StyledTableHeader>
        <RecordCountBadge text={'Rating Found'} count={data?.total || 0} />
      </StyledTableHeader>
      <Table<Package>
        loading={isLoading}
        dataSource={data?.items}
        rowKey='id'
        onChange={handleTableChange}
        pagination={{
          current: tableParams.page,
          defaultPageSize: tableParams.size,
          total: data?.total,
        }}
      >
        <Column
          title={'Name'}
          dataIndex={'user_name'}
          // width={screens.xxl ? 'auto' : 170}
          render={(_, record: any) => record.user_name}
        />
        <Column<UserWithithdraw>
          title={'Facility Name'}
          dataIndex={'facility_name'}
          // width={screens.xxl ? 'auto' : 170}
        />
        <Column<UserWithithdraw>
          title={'Rating Time'}
          dataIndex={'rating_time'}
          // width={screens.xxl ? 'auto' : 130}
        />
        <Column<UserWithithdraw>
          title={'Comment'}
          dataIndex={'comment'}
          render={(_, record: any) => <span>{record.comment}</span>}
        />
        <Column<UserWithithdraw>
          title={'Rating'}
          dataIndex={'rating'}
          render={(_, record: any) => <span>{record.rating}</span>}
        />
      </Table>
    </StyledTableWrapper>
  );
};
